import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BrandContext = createContext({ brand: {}, refresh: () => {} });

/**
 * BrandProvider — hydrates once from Admin › Global Settings + Brand Settings
 * so every component (Header, Footer, favicon, BrandMark…) can pull the
 * current logo URL, brand name, socials, colours from a single source.
 */
export const BrandProvider = ({ children }) => {
  const [brand, setBrand] = useState({});
  const refresh = async () => {
    try {
      const [g, b] = await Promise.all([
        axios.get(`${API}/settings/global`).catch(() => ({ data: {} })),
        axios.get(`${API}/settings/brand`).catch(() => ({ data: {} })),
      ]);
      const merged = { ...(b.data || {}), ...(g.data || {}) };
      setBrand(merged);
      // Also swap the favicon dynamically when the admin uploads one.
      if (merged.favicon) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
        link.href = merged.favicon;
      }
    } catch { /* keep previous brand */ }
  };
  useEffect(() => { refresh(); }, []);
  return <BrandContext.Provider value={{ brand, refresh }}>{children}</BrandContext.Provider>;
};

export const useBrand = () => useContext(BrandContext);
